import { css } from '@emotion/react';
import styled from '@emotion/styled';

const inputFieldBaseStyles = ({ theme, error, full }) => css`
  background-color: ${theme.colors.input.background};
  border: 1px solid
    ${error ? theme.colors.input.error : theme.colors.input.border};
  border-radius: ${theme.space[1]};
  color: ${theme.colors.input.text};
  font-size: ${theme.typography.texts.size2.fontSize};
  line-height: ${theme.typography.texts.size2.lineHeight};
  text-overflow: ellipsis;
  width: ${full && '100%'};

  &:focus {
    border-color: ${error
      ? theme.colors.input.error
      : theme.colors.input.focusBorder};
  }

  &::placeholder {
    color: ${error
      ? theme.colors.input.error
      : theme.colors.input.placeholderText};
  }

  ${theme.mediaQueries.lg} {
    font-size: ${theme.typography.texts.size1.fontSize};
    line-height: ${theme.typography.texts.size1.lineHeight};
  }
`;

const inputFieldPaddingStyles = ({ theme, iconLeft, iconRight }) => css`
  padding-top: ${theme.space[3]};
  padding-right: ${iconRight ? theme.space[8] : theme.space[4]};
  padding-bottom: ${theme.space[3]};
  padding-left: ${iconLeft ? theme.space[7] : theme.space[4]};

  ${theme.mediaQueries.md} {
    padding-top: ${theme.space[2]};
    padding-bottom: ${theme.space[2]};
  }
`;

const inputFieldDisabledStyles = ({ theme, disabled }) =>
  disabled &&
  css`
    background-color: ${theme.colors.input.disabledBackground};
    cursor: not-allowed;
    user-select: none;

    &:placeholder {
      color: ${theme.colors.input.disabledPlaceholderText};
    }
  `;

const StyledInputField = styled('input')`
  ${inputFieldBaseStyles}
  ${inputFieldPaddingStyles}
  ${inputFieldDisabledStyles}
`;

export default StyledInputField;
